import { useScroll as useFramerScroll } from 'framer-motion';
import { useEffect, useState } from 'react';

export const useScroll = () => {
  const { scrollY } = useFramerScroll();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    return scrollY.onChange(() => {
      setIsScrolled(scrollY.get() > 100);
      setIsScrolling(true);

      clearTimeout(timer);
      timer = setTimeout(() => {
        setIsScrolling(false);
      }, 150);
    });
  }, [scrollY]);

  return { isScrolled, isScrolling };
};
